export const data = {
    name: "General",
    layout: [],
};
export default data;